/**
 * REVIEW COMPANIES REDUX ACTIONS
 *
 * @version 0.1
 */

import { hashHistory } from 'react-router';

import reduxStore from './../../reduxStore';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';

import { POPUP_LIFETIME } from './../../constants';
import headerActions from './../../reusable/Header/Header.actions';
import popupActions from './../../reusable/MessagePopup/redux/MessagePopup.actions';
import addNewCategoryModalActions from './../../reusable/ReusableModals/AddNewCategoryModal/AddNewCategoryModal.actions';

import categoriesApi from './../../api/Categories.api';
import commonActions from './../../api/Common.actions';

import { POPULATE_NEXT_PREV } from './../PreviewCompany/PreviewCompany.actions';

// Define action constants
export const REVIEW_INITIAL_PHASE = 'REVIEW_INITIAL_PHASE';
export const REVIEW_CATEGORIES_LOADED = 'REVIEW_CATEGORIES_LOADED';
export const REVIEW_SELECT_ITEM = 'REVIEW_SELECT_ITEM';
export const REVIEW_DESELECT_ITEM = 'REVIEW_DESELECT_ITEM';
export const REVIEW_RESET_SELECTED_ITEMS = 'REVIEW_RESET_SELECTED_ITEMS';
export const REVIEW_TABLE_URL_CHANGE = 'REVIEW_TABLE_URL_CHANGE';
export const REVIEW_TOTAL_COUNT_CHANGE = 'REVIEW_TOTAL_COUNT_CHANGE';
export const REVIEW_FILTER_COUNT_CHANGE = 'REVIEW_FILTER_COUNT_CHANGE';
export const SET_PREVIEW_ITEMS = 'SET_PREVIEW_ITEMS';
export const SET_PREVIEW_ALL = 'SET_PREVIEW_ALL';
export const UPDATE_SELECTED_ITEMS = 'UPDATE_SELECTED_ITEMS';
export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
export const REMOVE_SELECTED_ITEMS = 'REMOVE_SELECTED_ITEMS';
export const REVIEW_COMPANIES_SET_MODALS_STATE = 'REVIEW_COMPANIES_SET_MODALS_STATE';
export const REVIEW_COMPANIES_SAVE_BUTTON = 'REVIEW_COMPANIES_SAVE_BUTTON';
export const REVIEW_COMPANIES_ACTIVATE_BUTTON = 'REVIEW_COMPANIES_ACTIVATE_BUTTON';

const actions = {

    resetReviewToInitial: () => {
        reduxStore.dispatch({type: 'REVIEW_INITIAL_PHASE'});
        headerActions.updateHeader('reviewCompanies');
    },

    loadCategories: () => {
        return categoriesApi
                .getCategoryNames()
                .then((categories)=>{
                    reduxStore.dispatch(
                        {
                            type:    'REVIEW_CATEGORIES_LOADED',
                            payload: categories
                        }
                    );
                    reduxStore.dispatch({type: 'HIDE_SPINNER'});
                    return categories;
                })
                .catch((error) => {
                    utils.logError(error, 'ReviewCompanies.actions.loadCategories(): ');
                    reduxStore.dispatch({type: 'HIDE_SPINNER'});
                    xhr.handleAllErrors(error);
                });
    },

    addNewCategory: (category, companies, spinner = true) => {
        if (spinner) {
            reduxStore.dispatch({type: 'SHOW_SPINNER'});
        }

        return xhr.post({
            url:  '/api/categories/category-with-entities',
            data: {
                categoryId: null,
                name:       category,
                companies:  companies
            }
        }).then(() => {
            reduxStore.dispatch({
                type:    REVIEW_COMPANIES_SET_MODALS_STATE,
                payload: ''
            });

            actions.loadCategories().then(() => {
                // TODO: We should find a solution for always needing a refresh whenever we update the state.
                actions.refreshTable();
            });
        }).catch((error) => {
            if (error.status === 400) {
                if (error.response && error.response.body && error.response.body.validationCode) {
                    let validationCode       = error.response.body.validationCode,
                        codesToMessageIdsMap = {
                            'api.error.category.duplicate':           'Entities_Review_UIText_reviewCompanies.categoryNameAlreadyExists',
                            'api.error.category.maximumSizeExceeded': 'Entities_Review_UIText_reviewCompanies.categoryMaxNameLengthExceeded'
                        };

                    addNewCategoryModalActions.setAddNewCategoryMessage(
                        codesToMessageIdsMap[validationCode] ? codesToMessageIdsMap[validationCode] : validationCode
                    );

                    throw 'SpecialErr400';
                } else {
                    utils.logError(error, 'ReviewCompanies.actions.addNewCategory(): ');
                }
                if (spinner) {
                    reduxStore.dispatch({type: 'HIDE_SPINNER'});
                }
            } else {
                xhr.handleAllErrors(error);
            }
        });

    },

    getSelectedCompanyIds: () => {
        let companyIds = [];
        let companies = reduxStore.getState().reviewCompanies.selectedItems;

        for (let i = 0; i < companies.length; i++) {
            companyIds.push(companies[i].id);
        }
        return companyIds;
    },

    selectItem: (item) => {
        reduxStore.dispatch({
            type:    REVIEW_SELECT_ITEM,
            payload: item
        });

        actions.checkForActiveItemsInSelectedItems();
    },

    deselectItem: (itemIndex) => {
        reduxStore.dispatch({
            type:    REVIEW_DESELECT_ITEM,
            payload: itemIndex
        });

        actions.checkForActiveItemsInSelectedItems();
    },

    checkForActiveItemsInSelectedItems: () => {

        let companies = reduxStore.getState().reviewCompanies.selectedItems;
        let areAllCompaniesSelectedActive = true;

        if (companies.length === 0) {
            actions.activateButtonDisabledAttribute(true);
            return;
        }

        for (let i = 0; i < companies.length; i++) {
            if (!companies[i].active) {
                areAllCompaniesSelectedActive = false;
                break;
            }
        }

        actions.activateButtonDisabledAttribute(areAllCompaniesSelectedActive);

    },

    activateButtonDisabledAttribute: (change) => {
        reduxStore.dispatch({
            type:    REVIEW_COMPANIES_ACTIVATE_BUTTON,
            payload: change
        });
    },

    resetSelectedItems: () => {
        reduxStore.dispatch({type: REVIEW_RESET_SELECTED_ITEMS});
    },

    changeTableUrlParams: (urlParams) => {
        reduxStore.dispatch({
            type:    REVIEW_TABLE_URL_CHANGE,
            payload: urlParams
        });

        let state = reduxStore.getState(),
            newUrlParams = state.reviewCompanies.urlParams;

        commonActions.updateUserPrefs({
                reviewCompanies: {
                    sortBy:    newUrlParams.sortBy,
                    direction: newUrlParams.direction
                }
            })
    },

    refreshTable: () => {
        let refreshToggle = reduxStore.getState().reviewCompanies.urlParams.refreshToggle;
        actions.checkForActiveItemsInSelectedItems();
        reduxStore.dispatch({
            type:    REVIEW_TABLE_URL_CHANGE,
            payload: {
                refreshToggle: refreshToggle === 0 ? 1 : 0
            }
        });
    },

    countEntries: (url, isStatusFilterApplied = false) => {
        reduxStore.dispatch({type: 'REVIEW_TOTAL_COUNT_CHANGE', payload: null});
        reduxStore.dispatch({type: 'REVIEW_FILTER_COUNT_CHANGE', payload: null});
        let params = reduxStore.getState().reviewCompanies.urlParams;

        let totalCountUrl = isStatusFilterApplied ? '/api/entities/companies/count' : url;

        xhr.get({
            url: totalCountUrl
        }).then((response) => {
            reduxStore.dispatch({type: 'REVIEW_TOTAL_COUNT_CHANGE', payload: response.body});

            if (!params.categoryIdFilter && !params.searchFilter && !isStatusFilterApplied) {
                reduxStore.dispatch({type: 'REVIEW_FILTER_COUNT_CHANGE', payload: response.body});
            }
            if (params.categoryIdFilter || params.searchFilter || isStatusFilterApplied) {
                let queryParams = {};

                if (params.categoryIdFilter) {
                    queryParams['categoryIdFilter'] = params.categoryIdFilter;
                }

                if (params.searchFilter) {
                    queryParams['searchFilter'] = params.searchFilter;
                }

                xhr.get({
                    url:  url,
                    data: queryParams
                }).then((response) => {
                    reduxStore.dispatch({type: 'REVIEW_FILTER_COUNT_CHANGE', payload: response.body});
                }).catch((error) => {
                    if (error.status === 400) {
                        utils.logError(error, 'ReviewCompanies.actions.countEntries(): ');
                        reduxStore.dispatch({type: 'REVIEW_FILTER_COUNT_CHANGE', payload: 0});
                    } else {
                        xhr.handleAllErrors(error);
                    }
                });
            }
        }).catch((error) => {
            if (error.status === 400) {
                utils.logError(error, 'ReviewCompanies.actions.countEntries(): ');
                reduxStore.dispatch({type: 'REVIEW_TOTAL_COUNT_CHANGE', payload: 0});
                reduxStore.dispatch({type: 'REVIEW_FILTER_COUNT_CHANGE', payload: 0});
            } else {
                xhr.handleAllErrors(error);
            }
        })
    },

    activateCompanies: (companyIds) => {
        reduxStore.dispatch({type: 'SHOW_SPINNER'});

        return xhr.post({
            url:  '/api/entities/companies/activate/',
            data: companyIds
        }).then((response) => {

            // Show the corresponding message on company activation.
            popupActions.setMessages({
                popupTitle: null,
                messages:   [
                    {
                        messageId:   'Entities_Review_UIText_reviewCompanies.selectedCompaniesActivated',
                        messageType: 'success'
                    }
                ]
            });

            // Hide the message after 5 seconds.
            setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            reduxStore.dispatch({type: 'HIDE_SPINNER'});
        }).catch((error) => {
            if (error.status === 400) {

                // Show the corresponding message on company activation.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Review_Error_reviewCompanies.companiesActivationError',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
                reduxStore.dispatch({type: 'HIDE_SPINNER'});

            } else {
                xhr.handleAllErrors(error);
            }

            console.log("********************** Failed to activate company ********************");
        });

    },

    showModal: (modalType) => {

        reduxStore.dispatch({
            type:    REVIEW_COMPANIES_SET_MODALS_STATE,
            payload: modalType
        });

    },

    deleteCompanies: (tableRef, tableId, companyIds) => {

        reduxStore.dispatch({
            type:    REVIEW_COMPANIES_SET_MODALS_STATE,
            payload: ''
        });

        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );

        return xhr.delete({
            url:  '/api/entities/companies/',
            data: companyIds
        }).then((response) => {

            // Clear the "selectedItems" array from the state
            actions.resetSelectedItems();

            reduxStore.dispatch(
                {
                    type: 'HIDE_SPINNER'
                }
            );

            // Show the corresponding message on company deletion.
            popupActions.setMessages({
                popupTitle: null,
                messages:   [
                    {
                        messageId:   'Entities_Review_UIText_reviewCompanies.selectedCompaniesDeleted',
                        messageType: 'success'
                    }
                ]
            });

            // Hide the message after 5 seconds.
            setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

        }).catch((error) => {
            if (error.status === 400) {
                reduxStore.dispatch(
                    {
                        type: 'HIDE_SPINNER'
                    }
                );

                // Show the corresponding message on company deletion error.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Review_Error_reviewCompanies.companiesDeletionError',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            } else {
                xhr.handleAllErrors(error);
            }

            console.log("********************** Failed to delete company ********************");
        });

    },

    activateAndShowNextCompany: (companyId, nextPrevious) => {

        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );

        return xhr.post({
            url:  '/api/entities/companies/activate/',
            data: [companyId]
        }).then((response) => {
            let store = reduxStore.getState().reviewCompanies;

            let previewCompanies = store.previewItems;

            let deletedIndex             = utils.inArray(companyId, previewCompanies, 'id'),
                newPreviewCompaniesArray = [...previewCompanies];

            newPreviewCompaniesArray.splice(deletedIndex, 1);
            actions.setPreviewItems(newPreviewCompaniesArray);

            reduxStore.dispatch(
                {
                    type: 'HIDE_SPINNER'
                }
            );

            // Navigate to the next or previous company or to the review page in case there are no more companies.
            if (!nextPrevious.nextCompany && !nextPrevious.previousCompany) {
                hashHistory.push('/review-companies');
            } else if (nextPrevious.nextCompany) {
                hashHistory.push('/preview-company/' + nextPrevious.nextCompany);
            } else if (nextPrevious.previousCompany) {
                hashHistory.push('/preview-company/' + nextPrevious.previousCompany);
            }

            return response;
        }).catch((error) => {
            if (error.status === 400) {
                reduxStore.dispatch(
                    {
                        type: 'HIDE_SPINNER'
                    }
                );

                // Show the corresponding message on company activation.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Review_Error_reviewCompanies.companiesActivationError',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            } else {
                xhr.handleAllErrors(error);
            }

            return Promise.reject(error);
        });

    },

    setPreviewItems: (previewItems) => {
        reduxStore.dispatch({
            type:    SET_PREVIEW_ITEMS,
            payload: {
                previewItems:     previewItems
            }
        });
    },

    setPreviewAll: (isPreviewAll) => {
        reduxStore.dispatch({
            type:    SET_PREVIEW_ALL,
            payload: {
                isPreviewAll:     isPreviewAll
            }
        });
    },

    addSelectedItems: (selectedItems) => {

        reduxStore.dispatch({
            type:    UPDATE_SELECTED_ITEMS,
            payload: selectedItems
        });

    },

    setSelectedItems: (selectedItems) => {

        reduxStore.dispatch({
            type:    SET_SELECTED_ITEMS,
            payload: selectedItems
        });

    },

    removeSelectedItems: (selectedItems) => {
        reduxStore.dispatch({
            type:    REMOVE_SELECTED_ITEMS,
            payload: selectedItems
        });
    },

    populateNextPrev: (companyId) => {
        let previewItems        = reduxStore.getState().reviewCompanies.previewItems,
            currentCompanyIndex = utils.inArray(companyId, previewItems, 'id'),
            nextId              = previewItems[currentCompanyIndex + 1] ?
                previewItems[currentCompanyIndex + 1].id : null,
            previousId          = currentCompanyIndex > 0 ? previewItems[currentCompanyIndex - 1].id : null;

        reduxStore.dispatch({
            type:    POPULATE_NEXT_PREV,
            payload: {
                next:     nextId,
                previous: previousId,
                current:  companyId
            }
        });

        if (nextId===null && reduxStore.getState().reviewCompanies.isPreviewAll) {
            reduxStore.dispatch({
                type:    POPULATE_NEXT_PREV,
                payload: {
                    next:     null,
                    previous: null,
                    current:  companyId
                }
            });

            actions.loadCompaniesData(previewItems.length)
                .then(()=>{
                    actions.populateNextPrev(companyId);
                });
        }
    },

    assignToCategory(selectedCategory, selectedCompanies) {

        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );

        return xhr.put({
            url:  '/api/actions/assign-category/' + selectedCategory,
            data: selectedCompanies
        }).then((response) => {
            reduxStore.dispatch(
                {
                    type: 'HIDE_SPINNER'
                }
            );

            // Show message of successful category assignment.
            popupActions.setMessages({
                popupTitle: null,
                messages:   [
                    {
                        messageId:   'Entities_Review_UIText_reviewCompanies.categoryAssignmentSuccessful',
                        messageType: 'success'
                    }
                ]
            });

            // Hide the message after 5 seconds.
            setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
        }).catch((error) => {
            if (error.status === 400) {
                reduxStore.dispatch(
                    {
                        type: 'HIDE_SPINNER'
                    }
                );

                // Show error message of category assignment failure.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Review_Error_reviewCompanies.categoryAssignmentFailure',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            } else {
                xhr.handleAllErrors(error);
            }

            console.log("********************** Failed to assign category ********************");
        });

    },

    unassignCategoryFromCompany(companyId, categoryId) {

        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );

        let data = categoryId + "/" + companyId;

        return xhr.put({
            url: '/api/actions/remove-category/' + data
        }).then((response) => {
            reduxStore.dispatch(
                {
                    type: 'HIDE_SPINNER'
                }
            );

            // Show message of successful category deletion.
            popupActions.setMessages({
                popupTitle: null,
                messages:   [
                    {
                        messageId:   'Entities_Review_UIText_reviewCompanies.categoryUnassignmentSuccessful',
                        messageType: 'success'
                    }
                ]
            });

            // Hide the message after 5 seconds.
            setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
        }).catch((error) => {
            if(error.status === 400) {
                reduxStore.dispatch(
                    {
                        type: 'HIDE_SPINNER'
                    }
                );

                // Show error message of category deletion failure.
                popupActions.setMessages({
                    popupTitle: null,
                    messages:   [
                        {
                            messageId:   'Entities_Review_Error_reviewCompanies.categoryUnassignmentFailure',
                            messageType: 'system-error'
                        }
                    ]
                });

                // Hide the message after 5 seconds.
                setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
            } else {
                xhr.handleAllErrors(error);
            }

            console.log("********************** Failed to delete category ********************");
        });

    },

    loadCompaniesData: (pageNo) => {
        let state = reduxStore.getState().reviewCompanies,
            queryParams = {
                pageNumber: pageNo,
                pageSize:   1,
                sortBy:     state.urlParams.sortBy,
                direction:  state.urlParams.direction
            };

        if (state.urlParams.categoryIdFilter) {
            queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
        }

        return xhr.get({
            url: '/api/entities/non-active',
            data: queryParams
        }).then((response)=> {
            let previewItems = [];
            if (state.previewItems) {
                previewItems = previewItems.concat(state.previewItems);
            }
            if (response.body.length > 0) {
                previewItems = previewItems.concat(response.body);
                actions.setPreviewItems(previewItems);
            } else {
                // reached the end - remove preview all behavior
                actions.setPreviewAll(false);
            }
        }).catch((err) => {
            console.log("********************** Failed to load next items ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    },

    syncData: () => {
        let url = '/api/entities/specific-companies';
        reduxStore.dispatch(
            {
                type: 'SHOW_SPINNER'
            }
        );
        return xhr.post({
            url: url,
            data: actions.getSelectedCompanyIds()
        }).then((response)=> {
            actions.setSelectedItems(response.body);
            reduxStore.dispatch(
                {
                    type: 'HIDE_SPINNER'
                }
            );
        }).catch((err) => {
            console.log("********************** Failed to sync selection store ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    },

    selectAll: (url) => {
        let state = reduxStore.getState().reviewCompanies,
            queryParams = {
                pageNumber: -1,
                pageSize: -1,
                sortBy: state.urlParams.sortBy,
                direction: state.urlParams.direction
            };

        if (state.urlParams.categoryIdFilter) {
            queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
        }

        if (state.urlParams.searchFilter) {
            queryParams['searchFilter'] = state.urlParams.searchFilter;
        }

        return xhr.get({
            url: url,
            data: queryParams
        }).then((response)=> {
            actions.addSelectedItems(response.body);
        }).catch((err) => {
            console.log("********************** Failed to select all ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    },

    unSelectAll: (url) => {
        let state = reduxStore.getState().reviewCompanies,
            queryParams = {
                pageNumber: -1,
                pageSize: -1,
                sortBy: state.urlParams.sortBy,
                direction: state.urlParams.direction
            };

        if (state.urlParams.categoryIdFilter) {
            queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
        }

        if (state.urlParams.searchFilter) {
            queryParams['searchFilter'] = state.urlParams.searchFilter;
        }

        return xhr.get({
            url: url,
            data: queryParams
        }).then((response)=> {
            actions.removeSelectedItems(response.body);
        }).catch((err) => {
            console.log("********************** Failed to select all ********************");
            console.log(err);
            xhr.handleAllErrors(err);
        });
    },

    toggleSaveButton: (change) => {
        reduxStore.dispatch({
            type:    REVIEW_COMPANIES_SAVE_BUTTON,
            payload: change
        });
    },

    startPreviewAll() {
        let previewAllQueryParams = {
            pageNumber: 0,
            pageSize:   1,
            sortBy:     'companyTitle',
            direction:  'asc'
        };
        // get the id of the first element and route to it
        return xhr.get({
            url:  '/api/entities/non-active',
            data: previewAllQueryParams
        }).then((response) => {
            if (response.body.length > 0 && response.body[0].id) {
                hashHistory.push('/preview-company/' + response.body[0].id);
                actions.getInactiveEntitiesCount();
            } else {
                hashHistory.push('/review-companies');
            }
        }).catch((error) => {
            utils.logError(error, 'ReviewCompanies.actions.startPreviewAll(): ');
            xhr.handleAllErrors(error);
        });
    },

    getInactiveEntitiesCount() {
        return xhr.get({
            url: '/api/entities/companies/non-active/count'
        }).then((response) => {
            reduxStore.dispatch({type: 'PREVIEW_INACTIVE_ENTITIES_COUNT', payload: response.body});
        }).catch((error) => {
            if (error.status === 400) {
                utils.logError(error, 'PreviewCompanies.actions.countEntries(): ');
            } else {
                xhr.handleAllErrors(error);
            }
        });
    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/ReviewCompanies/ReviewCompanies.actions.js